import { useState } from "react";
import { Link } from "react-router-dom";

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

// 1. 메뉴 데이터 정의
const menuData = [
  {
    id: "about",
    title: "회사소개",
    subItems: [
      { label: "경영이념", path: "/about/vision" },
      { label: "연혁", path: "/about/history" },
      { label: "보유기술 및 특허", path: "/about/technology" },
      { label: "주요 고객사", path: "/about/clients" },
      { label: "오시는 길", path: "/about/location" },
    ],
  },
  {
    id: "service",
    title: "서비스 소개",
    subItems: [
      { label: "문자콜센터 서비스", path: "/service-provide/voucher-aicc" },
      { label: "메시징 서비스", path: "/service-provide/messaging" },
    ],
  },
  {
    id: "inquiry",
    title: "문의",
    subItems: [
      { label: "문의 접수", path: "/voc/submit" },
      { label: "문의 조회", path: "/voc/check" },
    ],
  },
];

const MobileMenu = ({ isOpen, onClose }: MobileMenuProps) => {
  const [openSection, setOpenSection] = useState<string | null>("about");

  const toggleSection = (section: string) => {
    setOpenSection(prev => (prev === section ? null : section));
  };

  const isSectionOpen = (sectionId: string) => openSection === sectionId;
  return (
    <>
      {/* 배경 오버레이 */}
      <div
        className={`lg:hidden fixed inset-0 bg-black/50 z-[49] transition-opacity duration-300 ${
          isOpen ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
        onClick={onClose}
      />

      {/* 모바일 메뉴 컨텐츠 */}
      <nav
        className={`lg:hidden fixed top-0 right-0 w-[85%] max-w-[400px] h-full bg-white z-[50] transition-transform duration-300 transform ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        {/* 상단 헤더 영역 */}
        <div className="flex items-center justify-between px-6 py-5 border-b border-gray-100">
          <img src="/img/gnb_logo.png" alt="로고" className="h-8" />
          <div className="flex items-center gap-4">
            <a
              href="https://customer.std-ums.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-2 bg-navy text-white text-[1.4rem] font-bold rounded-md"
            >
              로그인
            </a>
            <button onClick={onClose} className="p-1">
              <span className="material-icons-round text-[2.8rem] text-gray-800">close</span>
            </button>
          </div>
        </div>

        {/* 메뉴 리스트 영역  */}
        <div className="overflow-y-auto h-[calc(100%-75px)]">
          <ul className="flex flex-col">
            {menuData.map(section => (
              <li key={section.id}>
                {/* 메인 메뉴 버튼 */}
                <button
                  onClick={() => toggleSection(section.id)}
                  className={`flex justify-between items-center w-full px-6 py-7 text-[2rem] font-bold border-b border-gray-50 ${
                    isSectionOpen(section.id) ? "text-std-blue" : "text-gray-900"
                  }`}
                >
                  {section.title}
                  <span
                    className={`material-icons-round transition-transform ${
                      isSectionOpen(section.id) ? "rotate-180" : ""
                    }`}
                  >
                    expand_more
                  </span>
                </button>

                {/* 서브 메뉴 리스트 */}
                <div
                  className={`bg-gray-50 overflow-hidden transition-all duration-300 ${
                    isSectionOpen(section.id) ? "max-h-[500px]" : "max-h-0"
                  }`}
                >
                  <ul className="px-8 py-4 space-y-5">
                    {section.subItems.map(subItem => (
                      <li key={subItem.path}>
                        <Link
                          to={subItem.path}
                          onClick={onClose}
                          className="block text-[1.6rem] text-gray-600 hover:text-std-blue"
                        >
                          {subItem.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </nav>
    </>
  );
};

export default MobileMenu;
